/**
 * trønso Scroll-Reveal: Sections unterhalb des Viewports treten beim
 * Scrollen sanft ein (Fade + leichtes Anheben, ease-out).
 *
 * Bewusst zurückhaltend:
 * - Sections, die beim Laden schon sichtbar sind, werden nicht animiert
 *   (kein Flackern beim First Paint, Sticky-Elemente bleiben unberührt).
 * - Im Theme-Editor (design mode) und bei prefers-reduced-motion passiert nichts.
 * - Ohne JS bleibt alles sichtbar, da die Ausgangsklasse erst hier vergeben wird.
 */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const sections = document.querySelectorAll('#MainContent .shopify-section');
  if (sections.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tronso-reveal--visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  for (const section of sections) {
    if (section.getBoundingClientRect().top < window.innerHeight * 0.85) continue;
    section.classList.add('tronso-reveal');
    observer.observe(section);
  }
})();
